exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-group-stage{line-height:54px;overflow:hidden}.input-group-stage .input-group-header{width:100px}.input-group-stage .input-group-header,.input-group-stage ul{display:inline-block;vertical-align:middle}.input-group-stage li{float:left;padding-right:45px}.input-group-stage li label em{width:100px;display:inline-block}.input-group-stage li label .form-control{display:inline-block;width:55px;text-align:center;padding:6px}.input-group-stage li .extra-info{display:inline-block}.input-group-stage li .extra-info em{width:60px;text-align:center;display:inline-block}.input-group-stage li .extra-info span{font-size:13px;color:#aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/components/common/input-group/input-group.scss
// module id = 585
// module chunks = 2